module.exports = __webpack_public_path__ + "img/xls.21969610.svg";